var exports = {
  "tp": "FeatureComparisonTable.module__table___V1FzSn",
  "wx": "FeatureComparisonTable.module__header___V1FzSn",
  "_j": "FeatureComparisonTable.module__headerFeature___V1FzSn",
  "t_": "FeatureComparisonTable.module__headerFeatureText___V1FzSn",
  "UE": "FeatureComparisonTable.module__headerValues___V1FzSn",
  "LX": "FeatureComparisonTable.module__headerRestricted___V1FzSn",
  "_b": "FeatureComparisonTable.module__headerStock___V1FzSn",
  "Ge": "FeatureComparisonTable.module__rows___V1FzSn",
};

module.exports = exports;
